import React from 'react';
import { observer } from 'mobx-react-lite';
import FilterIcon from '../FilterIcon';
import * as styles from '../Filter/Filter.scss';
import strings from '../../strings';

const AtiDocIcon = ({ atiDocs, handleAtiDocsClick }) => {
  const atiDocsImgUrlDefault = '/rating/assets/images/ati-docs.svg';
  const atiDocsImgUrlSelected = '/rating/assets/images/ati-docs-selected.svg';

  const atiDocIcon = (
    <img
      alt="ati-doc"
      className={styles.atiDocs}
      src={atiDocsImgUrlDefault}
    />
  );

  const atiDocIconSelected = (
    <img
      alt="ati-doc-selected"
      className={styles.atiDocs}
      src={atiDocsImgUrlSelected}
    />
  );
  const atiDocText = strings.atiDocs;

  return (
    <FilterIcon
      icon={atiDocIcon}
      iconSelected={atiDocIconSelected}
      text={atiDocText}
      pressed={atiDocs}
      handleClick={handleAtiDocsClick}
    />
  );
};

export default observer(AtiDocIcon);
